export const environment = {
  production: false,
  apiUrl: 'https://autorization-system-api-dev-h8fpd8g4hyhqa4db.westus2-01.azurewebsites.net/api/',
  baseUrl: 'https://authorizationsdemo.caribauto.zone/#',
};
